// extracted by mini-css-extract-plugin
export default {"wrapper":"Purpose_wrapper__ZaTQS","title":"Purpose_title__PrFGT","description":"Purpose_description__b66AQ","chart":"Purpose_chart__rfrvF"};